import React from 'react';
import styled from 'styled-components';

import { useModal } from '../../../Providers/ModalContext';
import Modal from '../../../Global/Modal';
import RichText from '../../../Global/RichText';
import List from '../../../Global/Lists';
import Slider from '../../../Global/Slider';

import CloseIcon from '../../../../Images/icons/close-icon.png';
import ServicesBg from '../../../../Images/background/bg_services.png';
import LogoFilms from '../../../../Images/logos/logo_films_nav.png';

import {
  Services_Title,
  List_Title_1,
  List_1,
  List_Title_2,
  List_2,
  List_Title_3,
  List_3,
  List_Title_4,
  List_4,
  List_Title_5,
  List_5,
  SLIDER_IMAGES,
} from '../../../../utils/ES/Modals/FilmsServices';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 0 55px;
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;

  h2 {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(147, 206, 255, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const ListsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  margin-top: 45px;

  @media (max-width: ${breakpoints.tablet}) {
    flex-wrap: wrap;
    gap: 2.188rem;
  }

  div {
    max-width: 349px;
    width: 100%;
    text-transform: uppercase;

    @media (max-width: ${breakpoints.mobile}) {
      max-width: 100%;
    }

    &:last-child {
      max-width: 390px;

      @media (max-width: ${breakpoints.mobile}) {
        max-width: 100%;
      }
    }

    .top {
      margin-top: 45px;
    }

    li {
      @media (max-width: ${breakpoints.mobile}) {
        font-size: 0.75rem;
        padding-left: 25px;
      }
    }
  }
`;

const SlideContainer = styled.div`
  width: 100%;
`;

const ModalFilmsServices = () => {
  const { closeModal } = useModal();

  return (
    <>
      <Modal id="films-services" bgImg={ServicesBg}>
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoFilms}
                alt="Kuter Films Reel"
                onClick={closeModal}
                aria-label="Close modal"
              />
            </LogoContent>
            <RichText dataText={Services_Title} />
          </TitleContent>
          <ListsContainer>
            <div>
              <RichText dataText={List_Title_1} />
              <List
                dataList={List_1}
                textSize={'1.25rem'}
                marginBottom={'0px'}
              />
            </div>
            <div>
              <RichText dataText={List_Title_2} />
              <List
                dataList={List_2}
                textSize={'1.25rem'}
                marginBottom={'0px'}
              />
            </div>
            <div>
              <RichText dataText={List_Title_3} />
              <List
                dataList={List_3}
                textSize={'1.25rem'}
                marginBottom={'0px'}
              />
            </div>
            <div>
              <RichText dataText={List_Title_4} />
              <List
                dataList={List_4}
                textSize={'1.25rem'}
                marginBottom={'0px'}
              />

              <RichText dataText={List_Title_5} className="top" />
              <List
                dataList={List_5}
                textSize={'1.25rem'}
                marginBottom={'0px'}
              />
            </div>
          </ListsContainer>
          <SlideContainer>
            <Slider slides={SLIDER_IMAGES} />
          </SlideContainer>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalFilmsServices;
